export type TFactTrajectoryPoint = {
  stationId?: number | null;
  md?: number | null;
  inc?: number | null;
  azi?: number | null;
  azMag?: number | null;
  azTrue?: number | null;
  aziGrid?: number | null;
  tvd?: number | null;
  tvdss?: number | null;
  ns?: number | null;
  we?: number | null;
  northing?: number | null;
  easting?: number | null;
  /** Projected CRS identity from station location (id or EPSG), for overlay compatibility. */
  projectedCrsKey?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  closure?: number | null;
  closureDirection?: number | null;
  vsec?: number | null;
  ahd?: number | null;
  ddi?: number | null;
  erd?: number | null;
  tortuosity?: number | null;
  upToPlan?: number | null;
  rightToPlan?: number | null;
  centrToCentr?: number | null;
  dls?: number | null;
  rateTurn?: number | null;
  rateBuild?: number | null;
  mdDelta?: number | null;
  tvdDelta?: number | null;
  tfo?: number | null;
  mtf?: number | null;
  gtf?: number | null;
  comment?: string | null;
  typeTrajStation?: string | null;
};

export const FACT_TRAJECTORY_POINT_KEYS = [
  'stationId',
  'md',
  'mdDelta',
  'tvdDelta',
  'inc',
  'azi',
  'azMag',
  'azTrue',
  'aziGrid',
  'tvd',
  'tvdss',
  'ns',
  'we',
  'northing',
  'easting',
  'latitude',
  'longitude',
  'dls',
  'tfo',
  'rateTurn',
  'rateBuild',
  'mtf',
  'gtf',
  'closure',
  'closureDirection',
  'vsec',
  'ahd',
  'ddi',
  'erd',
  'tortuosity',
  'upToPlan',
  'rightToPlan',
  'centrToCentr',
  'typeTrajStation',
  'comment',
] as const satisfies ReadonlyArray<keyof TFactTrajectoryPoint>;

export type TrajectoryPlanOrFact = 'plan' | 'fact';

export type TGraphTrajectoryRole = 'main' | 'reference';
